"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.border = void 0;
/**
 * @deprecated
 */
exports.border = {
    width: {
        none: '0',
        xs: '1px',
        sm: '2px',
        md: '4px',
        lg: '8px'
    },
    radius: {
        none: '0',
        xs: '0.25rem',
        sm: '0.5rem',
        md: '1rem',
        pill: '31.25rem',
        circular: '50%'
    }
};
